import React from "react";
import { useLocale } from "hooks";
import { TableTickIcon, TableCrossIcon } from "components/SvgIcons";
import type { ProductComparison } from "components/Shop/PDPPage/PDPPage.constants";
import {
  firstTableRow,
  dupeTableTd,
  pinkBgColor,
  tableCellText,
  tableHeaderText,
  tableElement,
  lastTableTd,
  tableTh,
  topDistance
} from "./Drawer.css";

type Props = {
  productComparison: ProductComparison;
};

const returnTableVal = (val: string | number, bold: boolean) => {
  if (val === "Yes") {
    return <TableTickIcon />;
  }
  if (val === "No") {
    return <TableCrossIcon />;
  }
  return (
    <p className={tableCellText} style={{ fontWeight: bold ? "600" : "300" }}>
      {val}
    </p>
  );
};

export const DupeTable: React.FC<Props> = ({ productComparison }) => {
  const locale = useLocale();

  return (
    <table className={tableElement}>
      <thead>
        <tr>
          {["", "Beauty Pie", productComparison.brand].map((header, index) => (
            <th
              key={header}
              className={`${index === 1 ? tableTh : topDistance}`}
            >
              <p className={tableHeaderText}>{header}</p>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Object.keys(productComparison.characteristics).map(
          (characteristic, arrayIndex, array) => (
            <>
              <tr>
                {[
                  characteristic,
                  productComparison.characteristics[characteristic].BP[locale],
                  productComparison.characteristics[characteristic].copy[locale]
                ].map((val, index) => (
                  <td
                    key={val}
                    className={`${index === 1 ? pinkBgColor : ""}
                    ${index === 0 ? firstTableRow : ""} 
                    ${dupeTableTd}
                    ${arrayIndex === array.length - 1 ? lastTableTd : ""} `}
                  >
                    <div>
                      {returnTableVal(val, arrayIndex === 0 && index === 1)}
                    </div>
                  </td>
                ))}
              </tr>
            </>
          )
        )}
      </tbody>
    </table>
  );
};
